// extracted by mini-css-extract-plugin
module.exports = {"collapse_head":"collapsable_collapse_head__7xqkq","collapse_body":"collapsable_collapse_body__2QfBA"};